export const ALL_CATEGORY_REQUEST = "ALL_CATEGORY_REQUEST";
export const ALL_CATEGORY_SUCCESS = "ALL_CATEGORY_SUCCESS";
export const ALL_CATEGORY_FAIL = "ALL_CATEGORY_FAIL";

export const ONE_CATEGORY_REQUEST = "ONE_CATEGORY_REQUEST";
export const ONE_CATEGORY_SUCCESS = "ONE_CATEGORY_SUCCESS";
export const ONE_CATEGORY_FAIL = "ONE_CATEGORY_FAIL";

export const CREATE_CATEGORY_SUCCESS = "CREATE_CATEGORY_SUCCESS";
export const CREATE_CATEGORY_FAIL = "CREATE_CATEGORY_FAIL";

export const UPDATE_CATEGORY_SUCCESS = "UPDATE_CATEGORY_SUCCESS";
export const UPDATE_CATEGORY_FAIL = "UPDATE_CATEGORY_FAIL";

export const DELETE_CATEGORY_SUCCESS = "DELETE_CATEGORY_SUCCESS";
export const DELETE_CATEGORY_FAIL = "DELETE_CATEGORY_FAIL";

export const RESET_CREATE_CATEGORY = "RESET_CREATE_CATEGORY";
export const RESET_DELETE_CATEGORY = "RESET_DELETE_CATEGORY";
export const RESET_UPDATE_CATEGORY = "RESET_UPDATE_CATEGORY";
